export default __webpack_public_path__ + "static/media/9.efdf7721.png";